
// 防抖
export function debounce(func, wait, immediate) {
    var timeout, result;

    var debounced = function() {
        var context = this;
        var args = arguments;

        if (timeout) {
            clearTimeout(timeout);
        }

        if (immediate) {
            // 如果已经执行过，不再执行
            var callNow = !timeout;
            timeout = setTimeout(function(){
                timeout = null;
            }, wait);

            if (callNow) {
                result = func.apply(context, args);
            }
        } else {
            timeout = setTimeout(function(){
                func.apply(context, args);
            }, wait);
        }

        return result;
    };

    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = null;
    };

    return debounced;
}

// 节流
export function throttle(func, wait) {
    var timeout, previous = 0;

    var throttled = function() {
        var now = +new Date();
        var context = this;
        var args = arguments;
        // 下次触发 func 剩余的时间
        var remaining = wait - (now - previous);

        // 如果没有剩余的时间了或者你改了系统时间
        if(remaining <= 0 || remaining > wait) {
            if(timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, arguments);
        } else if(!timeout){
            timeout = setTimeout(function () {
                previous = +new Date();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };

    throttled.cancel = function() {
        clearTimeout(timeout);
        timeout = null;
    };

    return throttled;
}



// WEBPACK FOOTER //
// ./src/utils/debounce.js